var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Radio from 'syf-component-library/ui/atoms/Radio';
const RadioCardWrapper = styled.div `
  padding: ${({ theme: { spacing } }) => `${spacing.medium}px ${spacing.base}px ${spacing.large}px`};
  box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 10px;

  ${({ $checked, theme }) => $checked && `border: 2px solid ${theme.colors.cyanBlue};`}

  ${({ $hasError, theme }) => $hasError && `border: 2px solid ${theme.colors.error};`}
`;
const RadioContainer = styled.div `
  height: 44px;
  display: flex;
  align-items: center;
`;
const HeadingLabel = styled.span `
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: ${({ theme }) => theme.fontSizes.root}px;
  line-height: ${({ theme }) => theme.lineHeights.root};

  height: 44px;
  display: flex;
  align-items: center;
`;
const Description = styled.p `
  margin-left: 35px;
  font-size: ${({ theme }) => theme.fontSizes.regular}px;
  line-height: ${({ theme }) => theme.lineHeights.small};
`;
const RadioCard = (_a) => {
    var { headingLabel, description, radioProps, onClick } = _a, props = __rest(_a, ["headingLabel", "description", "radioProps", "onClick"]);
    return (_jsxs(RadioCardWrapper, Object.assign({}, props, { "data-testid": "radio-card-wrapper", "$checked": radioProps.checked, "$hasError": radioProps.hasError, onClick: onClick }, { children: [_jsx(RadioContainer, { children: _jsx(Radio, Object.assign({}, radioProps, { children: _jsx(HeadingLabel, { children: headingLabel }) })) }), _jsx(Description, { children: description })] })));
};
export default RadioCard;
//# sourceMappingURL=index.js.map